const HeadQuarter = {

    // FIELDS
    "city": "Lungsod",
    "hq_name": "Pangalan ng Punong Tanggapan",
    "search": "Maghanap",

    // PAGE HEADER
    "hq": "Punong Tanggapan",

    // ERROR
    "error_city": "Piliin ang Lungsod",
    "error_hq_name": "Ilagay ang Pangalan ng Punong Tanggapan",

    // TABLE HEADER
    "table_city": "LUNGSOD",
    "table_hq_name": "PANGALAN NG PUNONG TANGGAPAN",

}

export default HeadQuarter;